import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchContactsUserQuotaThunk } from "../store/effects";

function useRevealQuotaFetchEffect() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchContactsUserQuotaThunk());
    }, []);
}

export default useRevealQuotaFetchEffect;
